module.exports = {"data":{"site":{"siteMetadata":{"title":"Common Energy"}},"allMarkdownRemark":{"totalCount":1,"edges":[{"node":{"fields":{"slug":"/blog/common-energy-corning-glass-announce-partnership/"},"frontmatter":{"title":"Common Energy & Corning Glass Announce Partnership"}}}]}},"pathContext":{"tag":"Partner"}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/tags-partner.json
// module id = 437
// module chunks = 145982143709654